<template>
  <div class="tooltip-container" @mouseover="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div v-if="show" class="tooltip-content" ref="tooltip" :class="positionClass">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  data() {
    return {
      show: false,
    };
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top', 'left-bottom', 'right-top', 'right-bottom'].includes(value)
    },
  },
  computed: {
    positionClass() {
      return `tooltip-${this.position}`;
    }
  },
  methods: {
    showTooltip() {
      this.show = true;
      this.$nextTick(() => {
        const tooltipEl = this.$refs.tooltip;
        const rect = tooltipEl.getBoundingClientRect();

        if (rect.right > window.innerWidth) {
          tooltipEl.style.left = "auto";
          tooltipEl.style.right = "0";
          tooltipEl.style.transform = "translateX(0)";
        } else if (rect.left < 0) {
          tooltipEl.style.left = "0";
          tooltipEl.style.transform = "translateX(0)";
        }
      });
    },
    hideTooltip() {
      this.show = false;
    },
  },
};
</script>

<style scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  background-color: black;
  color: white;
  padding: 5px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 99999;
  pointer-events: none;
}

.tooltip-top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 5px;
}

.tooltip-bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 5px;
}

.tooltip-left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 5px;
}

.tooltip-right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 5px;
}

.tooltip-top-left {
  bottom: 100%;
  left: 0;
  margin-bottom: 5px;
}

.tooltip-top-right {
  bottom: 100%;
  right: 0;
  margin-bottom: 5px;
}

.tooltip-bottom-left {
  top: 100%;
  left: 0;
  margin-top: 5px;
}

.tooltip-bottom-right {
  top: 100%;
  right: 0;
  margin-top: 5px;
}

.tooltip-left-top {
  right: 100%;
  top: 0;
  margin-right: 5px;
}

.tooltip-left-bottom {
  right: 100%;
  bottom: 0;
  margin-right: 5px;
}

.tooltip-right-top {
  left: 100%;
  top: 0;
  margin-left: 5px;
}

.tooltip-right-bottom {
  left: 100%;
  bottom: 0;
  margin-left: 5px;
}
</style>
